export const ORDR_FORMS: any[] = [
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "orderId", "orderName", "orderType", "billTo", "partyId", "billFrom", "storeName", "amount", "trackingCode", "statusId", "inventoryProblems", "authorisation", "pastETA", "rejectedItems", "partiallyReceived" ]
        } ],
        "columns" : [ {
            "name" : "orderDate",
            "title" : "Date"
        }, {
            "name" : "orderId",
            "title" : "Order ID"
        }, {
            "name" : "orderName",
            "title" : "Name"
        }, {
            "name" : "orderType",
            "title" : "Type"
        }, {
            "name" : "billTo",
            "title" : "Bill To Party"
        }, {
            "name" : "billFrom",
            "title" : "Bill From Party"
        }, {
            "name" : "storeName",
            "title" : "Store"
        }, {
            "name" : "amount",
            "title" : "Amount"
        }, {
            "name" : "trackingCode",
            "title" : "Tracking Code"
        }, {
            "name" : "statusId",
            "title" : "Status"
        },/*  {
            "name" : "inventoryProblems",
            "title" : "Inventory Problems"
        }, {
            "name" : "authorisation",
            "title" : "Authorisation"
        }, {
            "name" : "pastETA",
            "title" : "Past ETA"
        }, {
            "name" : "rejectedItems",
            "title" : "Rejected Items"
        }, {
            "name" : "partiallyReceived",
            "title" : "Partially Received"
        } */ ],
        "formName" : "OrderList",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/OrderForms.xml",
        "type" : "list",
        "fields" : [ {
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "orderDate",
            "description" : "",
            "id" : "OrderList_orderDate",
            "type" : "DISPLAY",
            "title" : "",
            "imageLocation" : ""
        }, {
            "image" : "",
            "width" : "",
            "name" : "orderId",
            "alternate" : "",
            "description" : " ",
            "type" : "HYPERLINK",
            "parameterList" : [ 
                {"name" : "orderId"},
                {"name" : "statusId"},
                {"name" : "partyId"} ],
            "id" : "OrderList_orderId",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "target" : "orderview",
            "event" :  "custom",
            "formData":{
                "formName":"EditOrder",
                "formLocation":"component://kwikstore/widget/ProductForms.xml",
                "link":"/admin/orders/sales/order/${orderId}/${statusId}/${partyId}/order-overview/custom"
            },
        }, {
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "orderName",
            "description" : "",
            "id" : "OrderList_orderName",
            "type" : "DISPLAY",
            "title" : "",
            "imageLocation" : ""
        }, {
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "orderType",
            "description" : "",
            "id" : "OrderList_orderType",
            "type" : "HIDDEN",
            "title" : "",
            "imageLocation" : ""
        }, {
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "billTo",
            "description" : "",
            "id" : "OrderList_billTo",
            "type" : "DISPLAY",
            "title" : "",
            "imageLocation" : ""
        }, {
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "partyId",
            "description" : "",
            "id" : "OrderList_partyId",
            "type" : "HIDDEN",
            "title" : "",
            "imageLocation" : ""
        },{
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "billFrom",
            "description" : "",
            "id" : "OrderList_billFrom",
            "type" : "DISPLAY",
            "title" : "",
            "imageLocation" : ""
        }, {
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "storeName",
            "description" : "",
            "id" : "OrderList_storeName",
            "type" : "DISPLAY",
            "title" : "",
            "imageLocation" : ""
        }, {
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "amount",
            "description" : "",
            "id" : "OrderList_amount",
            "type" : "DISPLAY",
            "title" : "",
            "imageLocation" : ""
        }, {
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "trackingCode",
            "description" : "",
            "id" : "OrderList_trackingCode",
            "type" : "DISPLAY",
            "title" : "",
            "imageLocation" : ""
        }, {
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "statusId",
            "description" : "",
            "id" : "OrderList_statusId",
            "type" : "DISPLAY",
            "title" : "",
            "imageLocation" : ""
        }, {
            name:"orderProblems",
            title:"Order Problems",
            type:"COMPOSITE",
            innerFields:[
                {
                    "name" : "inventoryProblems",
                    "title" : "Inventory Problems"                    
                },
                {
                    "name" : "authorisation",
                    "title" : "Authorisation"                    
                },
                {
                    "name" : "pastETA",
                    "title" : "Past ETA"                    
                },
                {
                    "name" : "rejectedItems",
                    "title" : "Rejected Items"                    
                },
                {
                    "name" : "partiallyReceived",
                    "title" : "Partially Received"                    
                }
            ]
        }, 
        {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "inventoryProblems",
            "description" : "",
            "style" : "",
            "id" : "OrderList_inventoryProblems",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "authorisation",
            "description" : "",
            "style" : "",
            "id" : "OrderList_authorisation",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "pastETA",
            "description" : "",
            "style" : "",
            "id" : "OrderList_pastETA",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "rejectedItems",
            "description" : "",
            "style" : "",
            "id" : "OrderList_rejectedItems",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "partiallyReceived",
            "description" : "",
            "style" : "",
            "id" : "OrderList_partiallyReceived",
            "title" : "",
            "type" : "DISPLAY",
            "imageLocation" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Order Header Fields",
            "fields" : [ "orderName", "orderTypeId", "orderStatusId", "partyId" ]
        }, {
            "fieldSetName" : "Order Party Fields",
            "fields" : [ "roleTypeId", "userLoginId", "billingAccountId", "createdBy", "isViewed", "productId" ]
        }, {
            "fieldSetName" : "Order Item Fields",
            "fields" : [ "goodIdentificationTypeId", "goodIdentificationIdValue", "inventoryItemId", "serialNumber", "softIdentifier", "productStoreId" ]
        }, {
            "fieldSetName" : "Order Channel Fields",
            "fields" : [ "orderWebSiteId", "salesChannelEnumId", "hasBackOrders" ]
        }, {
            "fieldSetName" : "Order Payment/Fulfillment Fields",
            "fields" : [ "shipmentMethod", "countryGeoId", "includeCountry", "gatewayAvsResult", "gatewayScoreResult", "filterInventoryProblems" ]
        }, {
            "fieldSetName" : "Problems",
            "fields" : [ "filterPartiallyReceivedPOs", "filterPOsOpenPastTheirETA", "filterPOsWithRejectedItems", "viewSize", "viewIndex", "correspondingPoId", "internalCode", "externalId", "minDate", "maxDate", "search" ]
        } ],
        "columns" : [ {
            "name" : "orderId",
            "title" : "Order ID"
        }, {
            "name" : "orderName",
            "title" : "Order Name"
        }, {
            "name" : "orderTypeId",
            "title" : "Order Type"
        }, {
            "name" : "orderStatusId",
            "title" : "Status"
        }, {
            "name" : "partyId",
            "title" : "${uiLabelMap.PartyPartyId"
        }, {
            "name" : "roleTypeId",
            "title" : "Role Type"
        }, {
            "name" : "userLoginId",
            "title" : "User Login ID"
        }, {
            "name" : "billingAccountId",
            "title" : "AccountingBillingAccount"
        }, {
            "name" : "createdBy",
            "title" : "Created By"
        }, {
            "name" : "isViewed",
            "title" : "Viewed"
        }, {
            "name" : "productId",
            "title" : "Product ID"
        }, {
            "name" : "goodIdentificationTypeId",
            "title" : "Good Identification Type"
        }, {
            "name" : "goodIdentificationIdValue",
            "title" : "Good Identification"
        }, {
            "name" : "inventoryItemId",
            "title" : "Inventory Item ID"
        }, {
            "name" : "serialNumber",
            "title" : "Serial Number"
        }, {
            "name" : "softIdentifier",
            "title" : "Soft Identifier"
        }, {
            "name" : "productStoreId",
            "title" : "${uiLabelMap.ProductProductStore"
        }, {
            "name" : "orderWebSiteId",
            "title" : "Web Site"
        }, {
            "name" : "salesChannelEnumId",
            "title" : "Sales Channel"
        }, {
            "name" : "hasBackOrders",
            "title" : "Contains BackOrders"
        }, {
            "name" : "shipmentMethod",
            "title" : "Select Shipping Method"
        }, {
            "name" : "countryGeoId",
            "title" : "Ship to Country"
        }, {
            "name" : "includeCountry",
            "title" : "Include Country"
        }, {
            "name" : "gatewayAvsResult",
            "title" : "Address Verification (AVS)"
        }, {
            "name" : "gatewayScoreResult",
            "title" : "Score"
        }, {
            "name" : "filterInventoryProblems",
            "title" : "Inventory Problems Filter"
        }, {
            "name" : "filterPartiallyReceivedPOs",
            "title" : "Partially Received Filter"
        }, {
            "name" : "filterPOsOpenPastTheirETA",
            "title" : "POs Open Past ETA Filter"
        }, {
            "name" : "filterPOsWithRejectedItems",
            "title" : "POs With Rejected Items Filter"
        }, {
            "name" : "correspondingPoId",
            "title" : "Customer PO#"
        }, {
            "name" : "internalCode",
            "title" : "Internal Code"
        }, {
            "name" : "externalId",
            "title" : "External ID"
        }, {
            "name" : "minDate",
            "title" : "From"
        }, {
            "name" : "maxDate",
            "title" : "Through"
        }, {
            "name" : "search",
            "title" : "Find"
        } ],
        "formName" : "FindOrders",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/OrderForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "viewSize",
            "action" : "",
            "id" : "FindOrders_viewSize",
            "type" : "HIDDEN",
            "event" : "",
            "value" : "20"
        }, {
            "conditionGroup" : "",
            "name" : "viewIndex",
            "action" : "",
            "id" : "FindOrders_viewIndex",
            "type" : "HIDDEN",
            "event" : "",
            "value" : "1"
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Order ID",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "orderId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "FindOrders_orderId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Order Name",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "orderName",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "FindOrders_orderName",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Order Type",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "FindOrders",
            "options" : [ {
            "description" : "Any Order Type",
            "key" : "_NA_"
            }, {
            "description" : "Purchase Order",
            "key" : "PURCHASE_ORDER"
            }, {
            "description" : "Sales Order",
            "key" : "SALES_ORDER"
            } ],
            "disabled" : "false",
            "id" : "FindOrders_orderTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "orderTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Status",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "FindOrders",
            "options" : [ {
            "description" : "Created",
            "key" : "ORDER_CREATED"
            }, {
            "description" : "Sent",
            "key" : "ORDER_SENT"
            }, {
            "description" : "Processing",
            "key" : "ORDER_PROCESSING"
            }, {
            "description" : "Approved",
            "key" : "ORDER_APPROVED"
            }, {
            "description" : "Held",
            "key" : "ORDER_HOLD"
            }, {
            "description" : "Completed",
            "key" : "ORDER_COMPLETED"
            }, {
            "description" : "Rejected",
            "key" : "ORDER_REJECTED"
            }, {
            "description" : "Cancelled",
            "key" : "ORDER_CANCELLED"
            } ],
            "disabled" : "false",
            "id" : "FindOrders_orderStatusId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "orderStatusId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldHelpText" : "",
            "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "",
            "type" : "LOOKUP",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "FindOrders",
            "id" : "FindOrders_partyId",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupPartyName",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "partyId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
            },
            "name" : "partyId",
            "style" : "",
            "id" : "FindOrders_partyId",
            "title" : "${uiLabelMap.PartyPartyId",
            "type" : "LOOKUP"
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Role Type",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "FindOrders",
            "options" : [ {
            "description" : "Account",
            "key" : "ACCOUNT"
            }, {
            "description" : "Account Lead",
            "key" : "ACCOUNT_LEAD"
            }, {
            "description" : "Accountant",
            "key" : "ACCOUNTANT"
            }, {
            "description" : "Addressee",
            "key" : "ADDRESSEE"
            }, {
            "description" : "Administrator",
            "key" : "ADMIN"
            }, {
            "description" : "Affiliate",
            "key" : "AFFILIATE"
            }, {
            "description" : "Agent",
            "key" : "AGENT"
            }, {
            "description" : "Approver",
            "key" : "APPROVER"
            }, {
            "description" : "Association",
            "key" : "ASSOCIATION"
            }, {
            "description" : "Automated Agent",
            "key" : "AUTOMATED_AGENT_ROLE"
            }, {
            "description" : "Bill-From-Vendor",
            "key" : "BILL_FROM_VENDOR"
            }, {
            "description" : "Bill-To Customer",
            "key" : "BILL_TO_CUSTOMER"
            }, {
            "description" : "Blind Copy",
            "key" : "BCC"
            }, {
            "description" : "Budget Application",
            "key" : "BUDGET_APPL"
            }, {
            "description" : "Budget Approver",
            "key" : "BUDGET_APPRV"
            }, {
            "description" : "Budget Manager",
            "key" : "BUDGET_MGR"
            }, {
            "description" : "Budget Reviewer",
            "key" : "BUDGET_RVR"
            }, {
            "description" : "Budget Roles Group (not to be assigned to parties)",
            "key" : "BUDGET"
            }, {
            "description" : "Bulk Customer",
            "key" : "BULK_CUSTOMER"
            }, {
            "description" : "Buyer",
            "key" : "BUYER"
            }, {
            "description" : "Calendar",
            "key" : "CALENDAR_ROLE"
            }, {
            "description" : "Calendar Attendee",
            "key" : "CAL_ATTENDEE"
            }, {
            "description" : "Calendar Delegate",
            "key" : "CAL_DELEGATE"
            }, {
            "description" : "Calendar Host",
            "key" : "CAL_HOST"
            }, {
            "description" : "Calendar Member",
            "key" : "ICAL_MEMBER"
            }, {
            "description" : "Calendar Organizer",
            "key" : "CAL_ORGANIZER"
            }, {
            "description" : "Calendar Owner",
            "key" : "CAL_OWNER"
            }, {
            "description" : "Carbon Copy",
            "key" : "CC"
            }, {
            "description" : "Carrier",
            "key" : "CARRIER"
            }, {
            "description" : "Cashier",
            "key" : "CASHIER"
            }, {
            "description" : "Client",
            "key" : "CLIENT"
            }, {
            "description" : "Client Analyst",
            "key" : "CLIENT_ANALYST"
            }, {
            "description" : "Client Billing",
            "key" : "CLIENT_BILLING"
            }, {
            "description" : "Client Manager",
            "key" : "CLIENT_MANAGER"
            }, {
            "description" : "Communication Participant",
            "key" : "COMMEVENT_ROLE"
            }, {
            "description" : "Competitor",
            "key" : "COMPETITOR"
            }, {
            "description" : "Consumer",
            "key" : "CONSUMER"
            }, {
            "description" : "Contact",
            "key" : "CONTACT"
            }, {
            "description" : "Content Administrator",
            "key" : "CONTENT_ADMIN"
            }, {
            "description" : "Content Author",
            "key" : "CONTENT_AUTHOR"
            }, {
            "description" : "Content Editor",
            "key" : "CONTENT_EDITOR"
            }, {
            "description" : "Content Guest",
            "key" : "CONTENT_GUEST"
            }, {
            "description" : "Content Member",
            "key" : "CONTENT"
            }, {
            "description" : "Content Publisher",
            "key" : "CONTENT_PUBLISHER"
            }, {
            "description" : "Content User",
            "key" : "CONTENT_USER"
            }, {
            "description" : "Contractor",
            "key" : "CONTRACTOR"
            }, {
            "description" : "Customer",
            "key" : "CUSTOMER"
            }, {
            "description" : "Department",
            "key" : "DEPARTMENT"
            }, {
            "description" : "Distribution Channel",
            "key" : "DISTRIBUTION_CHANNEL"
            }, {
            "description" : "Distributor",
            "key" : "DISTRIBUTOR"
            }, {
            "description" : "Division",
            "key" : "DIVISION"
            }, {
            "description" : "Email Administrator",
            "key" : "EMAIL_ADMIN"
            }, {
            "description" : "Employee",
            "key" : "EMPLOYEE"
            }, {
            "description" : "Employer",
            "key" : "EMPLOYER"
            }, {
            "description" : "End-User Customer",
            "key" : "END_USER_CUSTOMER"
            }, {
            "description" : "Family Member",
            "key" : "FAMILY_MEMBER"
            }, {
            "description" : "Fixed Asset Maint Assignee",
            "key" : "FAM_ASSIGNEE"
            }, {
            "description" : "Government Agency",
            "key" : "GOV_AGENCY"
            }, {
            "description" : "Hosting Server",
            "key" : "HOSTING_SERVER"
            }, {
            "description" : "Household",
            "key" : "HOUSEHOLD"
            }, {
            "description" : "ISP",
            "key" : "ISP"
            }, {
            "description" : "Image Approver",
            "key" : "IMAGEAPPROVER"
            }, {
            "description" : "Internal Organization",
            "key" : "INTERNAL_ORGANIZATIO"
            }, {
            "description" : "Lead",
            "key" : "LEAD"
            }, {
            "description" : "Limited Administrator",
            "key" : "LTD_ADMIN"
            }, {
            "description" : "Logged In",
            "key" : "LOGGEDIN"
            }, {
            "description" : "Main Role",
            "key" : "MAIN_ROLE"
            }, {
            "description" : "Maintenance Manager or Supervisor",
            "key" : "FAM_MANAGER"
            }, {
            "description" : "Maintenance Supplier or Service",
            "key" : "FAM_SUPPLIER"
            }, {
            "description" : "Maintenance Worker",
            "key" : "FAM_WORKER"
            }, {
            "description" : "Manager",
            "key" : "MANAGER"
            }, {
            "description" : "Manufacturer",
            "key" : "MANUFACTURER"
            }, {
            "description" : "Not Applicable",
            "key" : "_NA_"
            }, {
            "description" : "Order Clerk",
            "key" : "ORDER_CLERK"
            }, {
            "description" : "Organization",
            "key" : "ORGANIZATION_ROLE"
            }, {
            "description" : "Organization Unit",
            "key" : "ORGANIZATION_UNIT"
            }, {
            "description" : "Originator",
            "key" : "ORIGINATOR"
            }, {
            "description" : "Other Internal",
            "key" : "OTHER_INTERNAL_ORGAN"
            }, {
            "description" : "Other Organization Unit",
            "key" : "OTHER_ORGANIZATION_U"
            }, {
            "description" : "Owner",
            "key" : "OWNER"
            }, {
            "description" : "Packer",
            "key" : "PACKER"
            }, {
            "description" : "Parent Organization",
            "key" : "PARENT_ORGANIZATION"
            }, {
            "description" : "Partner",
            "key" : "PARTNER"
            }, {
            "description" : "Person",
            "key" : "PERSON_ROLE"
            }, {
            "description" : "Picker",
            "key" : "PICKER"
            }, {
            "description" : "Placing Customer",
            "key" : "PLACING_CUSTOMER"
            }, {
            "description" : "Product Owner",
            "key" : "PRODUCT_OWNER"
            }, {
            "description" : "Product Owner Company",
            "key" : "PRODUCT_OWNER_COMP"
            }, {
            "description" : "Project Team",
            "key" : "PROJECT_TEAM"
            }, {
            "description" : "Prospect",
            "key" : "PROSPECT"
            }, {
            "description" : "Provider Accounting",
            "key" : "PROVIDER_ACCOUNTING"
            }, {
            "description" : "Provider Analyst",
            "key" : "PROVIDER_ANALYST"
            }, {
            "description" : "Provider Functional",
            "key" : "PROVIDER_FUNCTIONAL"
            }, {
            "description" : "Provider Manager",
            "key" : "PROVIDER_MANAGER"
            }, {
            "description" : "Provider Tester",
            "key" : "PROVIDER_TESTER"
            }, {
            "description" : "Provider Validator",
            "key" : "PROVIDER_VALIDATOR"
            }, {
            "description" : "Receiver",
            "key" : "RECEIVER"
            }, {
            "description" : "Referrer",
            "key" : "REFERRER"
            }, {
            "description" : "Regulatory Agency",
            "key" : "REGULATORY_AGENCY"
            }, {
            "description" : "Request Manager",
            "key" : "REQ_MANAGER"
            }, {
            "description" : "Request Respondent",
            "key" : "REQ_RESPOND"
            }, {
            "description" : "Request Role",
            "key" : "REQUEST_ROLE"
            }, {
            "description" : "Request Taker",
            "key" : "REQ_TAKER"
            }, {
            "description" : "Requesting Party",
            "key" : "REQ_REQUESTER"
            }, {
            "description" : "Reviewer",
            "key" : "REVIEWER"
            }, {
            "description" : "SCRUM Master",
            "key" : "SCRUM_MASTER"
            }, {
            "description" : "SCRUM Team",
            "key" : "SCRUM_TEAM"
            }, {
            "description" : "Sales Force Autm.",
            "key" : "SFA_ROLE"
            }, {
            "description" : "Sales Representative",
            "key" : "SALES_REP"
            }, {
            "description" : "Scrum Member",
            "key" : "SCRUM_MEMBER"
            }, {
            "description" : "Shareholder",
            "key" : "SHAREHOLDER"
            }, {
            "description" : "Ship-From Vendor",
            "key" : "SHIP_FROM_VENDOR"
            }, {
            "description" : "Ship-To Customer",
            "key" : "SHIP_TO_CUSTOMER"
            }, {
            "description" : "Shipment Clerk",
            "key" : "SHIPMENT_CLERK"
            }, {
            "description" : "Sponsor",
            "key" : "SPONSOR"
            }, {
            "description" : "Spouse",
            "key" : "SPOUSE"
            }, {
            "description" : "Stakeholder",
            "key" : "STAKEHOLDER"
            }, {
            "description" : "Stocker",
            "key" : "STOCKER"
            }, {
            "description" : "Subscriber",
            "key" : "SUBSCRIBER"
            }, {
            "description" : "Subsidiary",
            "key" : "SUBSIDIARY"
            }, {
            "description" : "Supplier",
            "key" : "SUPPLIER"
            }, {
            "description" : "Supplier Agent",
            "key" : "SUPPLIER_AGENT"
            }, {
            "description" : "Tax Authority",
            "key" : "TAX_AUTHORITY"
            }, {
            "description" : "Union",
            "key" : "UNION"
            }, {
            "description" : "Vendor",
            "key" : "VENDOR"
            }, {
            "description" : "Visitor",
            "key" : "VISITOR"
            }, {
            "description" : "Web Master",
            "key" : "WEB_MASTER"
            }, {
            "description" : "Worker",
            "key" : "WORKER"
            }, {
            "description" : "Workflow",
            "key" : "WORKFLOW_ROLE"
            }, {
            "description" : "Workflow Owner",
            "key" : "WF_OWNER"
            } ],
            "disabled" : "false",
            "id" : "FindOrders_roleTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "roleTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldHelpText" : "",
            "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "",
            "type" : "LOOKUP",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "FindOrders",
            "id" : "FindOrders_userLoginId",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupUserLoginAndPartyDetails",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "userLoginId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
            },
            "name" : "userLoginId",
            "style" : "",
            "id" : "FindOrders_userLoginId",
            "title" : "User Login ID",
            "type" : "LOOKUP"
        }, {
            "fieldHelpText" : "",
            "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "",
            "type" : "LOOKUP",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "FindOrders",
            "id" : "FindOrders_billingAccountId",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupBillingAccount",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "billingAccountId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
            },
            "name" : "billingAccountId",
            "style" : "",
            "id" : "FindOrders_billingAccountId",
            "title" : "AccountingBillingAccount",
            "type" : "LOOKUP"
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Created By",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "createdBy",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "FindOrders_createdBy",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Viewed",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "FindOrders",
            "options" : [ {
            "description" : "Y",
            "key" : "Y"
            }, {
            "description" : "N",
            "key" : "N"
            } ],
            "disabled" : "false",
            "id" : "FindOrders_isViewed",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "isViewed",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldHelpText" : "",
            "lookupOptions" : {
            "ajaxUrl" : "",
            "fadeBackground" : "true",
            "conditionGroup" : "",
            "targetParameterList" : [ "" ],
            "className" : "",
            "type" : "LOOKUP",
            "presentation" : "layer",
            "initiallyCollapsed" : "false",
            "ajaxEnabled" : "true",
            "showDescription" : "true",
            "delegatorName" : "",
            "readonly" : "false",
            "alert" : "false",
            "formName" : "FindOrders",
            "id" : "FindOrders_productId",
            "event" : "",
            "value" : "",
            "fieldFormName" : "LookupProduct",
            "maxlength" : "",
            "autocomplete" : "",
            "clearText" : "Clear",
            "tabindex" : "",
            "size" : "25",
            "name" : "productId",
            "descriptionFieldName" : "",
            "position" : "topleft",
            "imgSrc" : ""
            },
            "name" : "productId",
            "style" : "",
            "id" : "FindOrders_productId",
            "title" : "Product ID",
            "type" : "LOOKUP"
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Good Identification Type",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "FindOrders",
            "options" : [ {
            "description" : "EAN",
            "key" : "EAN"
            }, {
            "description" : "Harmonized System Codes (HS Code)",
            "key" : "HS_CODE"
            }, {
            "description" : "ISBN",
            "key" : "ISBN"
            }, {
            "description" : "Library of Congress",
            "key" : "LOC"
            }, {
            "description" : "Manufacturer (Model) Number",
            "key" : "MANUFACTURER_ID_NO"
            }, {
            "description" : "Model Year",
            "key" : "MODEL_YEAR"
            }, {
            "description" : "Other",
            "key" : "OTHER_ID"
            }, {
            "description" : "SKU",
            "key" : "SKU"
            }, {
            "description" : "UPCA",
            "key" : "UPCA"
            }, {
            "description" : "UPCE",
            "key" : "UPCE"
            }, {
            "description" : "replacement value for partyId in the invoice export function in accounting",
            "key" : "INVOICE_EXPORT"
            } ],
            "disabled" : "false",
            "id" : "FindOrders_goodIdentificationTypeId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "goodIdentificationTypeId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Good Identification",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "goodIdentificationIdValue",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "FindOrders_goodIdentificationIdValue",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Inventory Item ID",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "inventoryItemId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "FindOrders_inventoryItemId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Serial Number",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "serialNumber",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "FindOrders_serialNumber",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Soft Identifier",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "softIdentifier",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "FindOrders_softIdentifier",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "${uiLabelMap.ProductProductStore",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "FindOrders",
            "options" : [ {
            "description" : "Flowers All Over",
            "key" : "10140"
            }, {
            "description" : "High Five",
            "key" : "10170"
            }, {
            "description" : "Kwikstore",
            "key" : "KWIKSTORE"
            }, {
            "description" : "Louis Stores",
            "key" : "10131"
            }, {
            "description" : "Loving This",
            "key" : "10180"
            }, {
            "description" : "Lucky Stores",
            "key" : "10181"
            }, {
            "description" : "My Store",
            "key" : "10150"
            }, {
            "description" : "OFBiz E-Commerce Store",
            "key" : "9000"
            }, {
            "description" : "OFBiz Physical Retail Store",
            "key" : "9100"
            }, {
            "description" : "Open Travel system Demo Site",
            "key" : "RentalStore"
            }, {
            "description" : "Revolution",
            "key" : "10197"
            }, {
            "description" : "Some Name",
            "key" : "10220"
            }, {
            "description" : "Some Name",
            "key" : "10209"
            }, {
            "description" : "Some Name",
            "key" : "10206"
            }, {
            "description" : "Some Name",
            "key" : "10190"
            }, {
            "description" : "Some Name",
            "key" : "10186"
            }, {
            "description" : "Some Name",
            "key" : "10185"
            }, {
            "description" : "Some Name",
            "key" : "10182"
            }, {
            "description" : "Some Store",
            "key" : "10221"
            }, {
            "description" : "Some Store",
            "key" : "10207"
            }, {
            "description" : "Some Store",
            "key" : "10205"
            }, {
            "description" : "Some Store",
            "key" : "10130"
            }, {
            "description" : "State Capture",
            "key" : "10196"
            }, {
            "description" : "Store of lies",
            "key" : "10195"
            }, {
            "description" : "Test Store 1",
            "key" : "10210"
            }, {
            "description" : "Test Store 1",
            "key" : "10204"
            }, {
            "description" : "Test Store 1",
            "key" : "10203"
            }, {
            "description" : "Test Store 1",
            "key" : "10199"
            }, {
            "description" : "Test Store 1",
            "key" : "10193"
            }, {
            "description" : "Test Store 1",
            "key" : "10192"
            }, {
            "description" : "Test Store 1",
            "key" : "10191"
            }, {
            "description" : "Test Store 1",
            "key" : "10184"
            }, {
            "description" : "Test Store 2",
            "key" : "10202"
            }, {
            "description" : "Test Store 2",
            "key" : "10200"
            }, {
            "description" : "Test Store 2",
            "key" : "10187"
            }, {
            "description" : "Test Store 2",
            "key" : "10183"
            }, {
            "description" : "Test Store 2",
            "key" : "10020"
            }, {
            "description" : "Test Store 3",
            "key" : "10030"
            }, {
            "description" : "Test Store 4",
            "key" : "10040"
            }, {
            "description" : "Test Store 5",
            "key" : "10050"
            }, {
            "description" : "Test Store 6",
            "key" : "10208"
            }, {
            "description" : "Test Store 6",
            "key" : "10201"
            }, {
            "description" : "Test Store 6",
            "key" : "10198"
            }, {
            "description" : "Test Store 6",
            "key" : "10189"
            }, {
            "description" : "Test Store 6",
            "key" : "10188"
            }, {
            "description" : "Test Store 6",
            "key" : "10120"
            }, {
            "description" : "Test Store 6",
            "key" : "10110"
            }, {
            "description" : "Test Store 6",
            "key" : "10100"
            }, {
            "description" : "Test Store 6",
            "key" : "10090"
            }, {
            "description" : "Test Store 6",
            "key" : "10080"
            }, {
            "description" : "Test Store 6",
            "key" : "10070"
            }, {
            "description" : "Test Store 6",
            "key" : "10060"
            }, {
            "description" : "This Store",
            "key" : "10160"
            }, {
            "description" : "Zulu Twak",
            "key" : "10194"
            } ],
            "disabled" : "false",
            "id" : "FindOrders_productStoreId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "productStoreId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Web Site",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "FindOrders",
            "options" : [ ],
            "disabled" : "false",
            "id" : "FindOrders_orderWebSiteId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "orderWebSiteId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Sales Channel",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "FindOrders",
            "options" : [ {
            "description" : "Web Channel",
            "key" : "WEB_SALES_CHANNEL"
            }, {
            "description" : "Fax Channel",
            "key" : "FAX_SALES_CHANNEL"
            }, {
            "description" : "Phone Channel",
            "key" : "PHONE_SALES_CHANNEL"
            }, {
            "description" : "E-Mail Channel",
            "key" : "EMAIL_SALES_CHANNEL"
            }, {
            "description" : "Snail Mail Channel",
            "key" : "SNAIL_SALES_CHANNEL"
            }, {
            "description" : "Affiliate Channel",
            "key" : "AFFIL_SALES_CHANNEL"
            }, {
            "description" : "eBay Channel",
            "key" : "EBAY_SALES_CHANNEL"
            }, {
            "description" : "POS Channel",
            "key" : "POS_SALES_CHANNEL"
            }, {
            "description" : "Unknown Channel",
            "key" : "UNKNWN_SALES_CHANNEL"
            } ],
            "disabled" : "false",
            "id" : "FindOrders_salesChannelEnumId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "salesChannelEnumId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Contains BackOrders",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "FindOrders",
            "options" : [ {
            "description" : "Y",
            "key" : "Y"
            }, {
            "description" : "N",
            "key" : "N"
            } ],
            "disabled" : "false",
            "id" : "FindOrders_hasBackOrders",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "hasBackOrders",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Select Shipping Method",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "FindOrders",
            "options" : [ ],
            "disabled" : "false",
            "id" : "FindOrders_shipmentMethod",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "shipmentMethod",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Ship to Country",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "FindOrders",
            "options" : [ {
            "description" : "{uiLabelMap.CommonAny}",
            "key" : "_NA_"
            }, {
            "description" : "Created",
            "key" : "ORDER_CREATED"
            }, {
            "description" : "Sent",
            "key" : "ORDER_SENT"
            }, {
            "description" : "Processing",
            "key" : "ORDER_PROCESSING"
            }, {
            "description" : "Approved",
            "key" : "ORDER_APPROVED"
            }, {
            "description" : "Held",
            "key" : "ORDER_HOLD"
            }, {
            "description" : "Completed",
            "key" : "ORDER_COMPLETED"
            }, {
            "description" : "Rejected",
            "key" : "ORDER_REJECTED"
            }, {
            "description" : "Cancelled",
            "key" : "ORDER_CANCELLED"
            } ],
            "disabled" : "false",
            "id" : "FindOrders_countryGeoId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "countryGeoId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Include Country",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "Y",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "FindOrders",
            "options" : [ {
            "description" : "Y",
            "key" : "Y"
            }, {
            "description" : "N",
            "key" : "N"
            } ],
            "disabled" : "false",
            "id" : "FindOrders_includeCountry",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "includeCountry",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Address Verification (AVS)",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "gatewayAvsResult",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "FindOrders_gatewayAvsResult",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Score",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "gatewayScoreResult",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "FindOrders_gatewayScoreResult",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldHelpText" : "",
            "conditionGroup" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Inventory Problems Filter",
            "type" : "CHECK",
            "allChecked" : "false",
            "alert" : "false",
            "name" : "filterInventoryProblems",
            "style" : "",
            "disabled" : "false",
            "id" : "FindOrders_filterInventoryProblems",
            "event" : "",
            "items" : {
            "description" : " ",
            "value" : "Y"
            }
        }, {
            "fieldHelpText" : "",
            "conditionGroup" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Partially Received Filter",
            "type" : "CHECK",
            "allChecked" : "false",
            "alert" : "false",
            "name" : "filterPartiallyReceivedPOs",
            "style" : "",
            "disabled" : "false",
            "id" : "FindOrders_filterPartiallyReceivedPOs",
            "event" : "",
            "items" : {
            "description" : " ",
            "value" : "Y"
            }
        }, {
            "fieldHelpText" : "",
            "conditionGroup" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "POs Open Past ETA Filter",
            "type" : "CHECK",
            "allChecked" : "false",
            "alert" : "false",
            "name" : "filterPOsOpenPastTheirETA",
            "style" : "",
            "disabled" : "false",
            "id" : "FindOrders_filterPOsOpenPastTheirETA",
            "event" : "",
            "items" : {
            "description" : " ",
            "value" : "Y"
            }
        }, {
            "fieldHelpText" : "",
            "conditionGroup" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "POs With Rejected Items Filter",
            "type" : "CHECK",
            "allChecked" : "false",
            "alert" : "false",
            "name" : "filterPOsWithRejectedItems",
            "style" : "",
            "disabled" : "false",
            "id" : "FindOrders_filterPOsWithRejectedItems",
            "event" : "",
            "items" : {
            "description" : " ",
            "value" : "Y"
            }
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Customer PO#",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "correspondingPoId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "FindOrders_correspondingPoId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Internal Code",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "internalCode",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "FindOrders_internalCode",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "External ID",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "externalId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "FindOrders_externalId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "From",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2024-12-05%2015:19:16.441",
            "timeDropdown" : "text",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "FindOrders",
            "timeDropdownParamName" : "minDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "FindOrders_minDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "minDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Through",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2024-12-05%2015:19:16.443",
            "timeDropdown" : "text",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "FindOrders",
            "timeDropdownParamName" : "maxDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "FindOrders_maxDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "maxDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "FindOrders",
            "tabindex" : "",
            "name" : "search",
            "className" : "smallSubmit",
            "id" : "FindOrders_search",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Find",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "storeName", "orderName", "orderDate", "currencyUom", "internalCode", "salesChannel", "originFacilityId", "createdBy", "agreementId" ]
        } ],
        "formName" : "OrderInfo",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/OrderViewForms.xml",
        "type" : "single",
        "fields" : [  {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "orderTypeId",
            "description" : "",
            "style" : "",
            "id" : "OrderInfo_orderTypeId",
            "title" : "Order Type",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "storeName",
            "description" : "",
            "style" : "",
            "id" : "OrderInfo_storeName",
            "title" : "Store Name",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "orderName",
            "description" : "",
            "style" : "",
            "id" : "OrderInfo_orderName",
            "title" : "Order Name",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "orderDate",
            "description" : "",
            "style" : "",
            "id" : "OrderInfo_orderDate",
            "title" : "Date Ordered",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "currencyUom",
            "description" : "",
            "style" : "",
            "id" : "OrderInfo_currencyUom",
            "title" : "Currency",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "internalCode",
            "description" : "",
            "style" : "",
            "id" : "OrderInfo_internalCode",
            "title" : "Internal Code",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "salesChannel",
            "description" : "Web Sales Channel",
            "style" : "",
            "id" : "OrderInfo_salesChannel",
            "title" : "Sales Channel",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "originFacilityId",
            "description" : "",
            "style" : "",
            "id" : "OrderInfo_originFacilityId",
            "title" : "Origin Facility",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "createdBy",
            "description" : "",
            "style" : "",
            "id" : "OrderInfo_createdBy",
            "title" : "Created By",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "agreementId",
            "description" : "",
            "style" : "",
            "id" : "OrderInfo_agreementId",
            "title" : "AccountingAgreement",
            "type" : "DISPLAY",
            "imageLocation" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "partyId" ]
        } ],
        "columns" : [ {
            "name" : "roleTypeId",
            "title" : "Role Type ID"
        }, {
            "name" : "partyId",
            "title" : "Party ID"
        } ],
        "formName" : "ListOrderRoles",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/OrderViewForms.xml",
        "type" : "list",
        "fields" : [ {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "roleTypeId",
            "description" : "",
            "style" : "",
            "id" : "ListOrderRoles_roleTypeId",
            "title" : "Role Type ID",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "partyId",
            "description" : "",
            "style" : "",
            "id" : "ListOrderRoles_partyId",
            "title" : "Party ID",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "orderItemSeqId", "productId", "itemDescription", "unitPrice", "subTotal" ]
        } ],
        "columns" : [ {
            "name" : "orderId",
            "title" : "Order ID"
        }, {
            "name" : "orderItemSeqId",
            "title" : "Order Item Seq ID"
        }, {
            "name" : "productId",
            "title" : "Product ID"
        }, {
            "name" : "itemDescription",
            "title" : "Description"
        }, {
            "name" : "unitPrice",
            "title" : "Item Unit Price"
        }, {
            "name" : "subTotal",
            "title" : "Sub Total"
        } ],
        "formName" : "OrderItemsMaster",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/OrderViewForms.xml",
        "type" : "list",
        "fields" : [ {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "orderId",
            "description" : "WSCO10731",
            "style" : "",
            "id" : "OrderItemsMaster_orderId",
            "title" : "Order ID",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "orderItemSeqId",
            "description" : "",
            "style" : "",
            "id" : "OrderItemsMaster_orderItemSeqId",
            "title" : "Order Item Seq ID",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productId",
            "description" : "",
            "style" : "",
            "id" : "OrderItemsMaster_productId",
            "title" : "Product ID",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "itemDescription",
            "description" : "",
            "style" : "",
            "id" : "OrderItemsMaster_itemDescription",
            "title" : "Description",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "unitPrice",
            "description" : "",
            "style" : "",
            "id" : "OrderItemsMaster_unitPrice",
            "title" : "Item Unit Price",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "subTotal",
            "description" : "",
            "style" : "",
            "id" : "OrderItemsMaster_subTotal",
            "title" : "Sub Total",
            "type" : "DISPLAY",
            "imageLocation" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "orderItemSeqId", "orderItemTypeId", "productId", "quantity", "unitPrice", "itemDescription" ]
        } ],
        "formName" : "EditOrderItem",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/OrderViewForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "orderId",
            "action" : "",
            "id" : "EditOrderItem_orderId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : "WSCO10731"
        }, {
            "conditionGroup" : "",
            "name" : "orderItemSeqId",
            "action" : "",
            "id" : "EditOrderItem_orderItemSeqId",
            "type" : "DISPLAY",
            "event" : "",
            "title" : "Order Item Seq ID",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "orderItemTypeId",
            "action" : "",
            "id" : "EditOrderItem_orderItemTypeId",
            "type" : "DISPLAY",
            "event" : "",
            "title" : "Order Item Type",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "productId",
            "action" : "",
            "id" : "EditOrderItem_productId",
            "type" : "DISPLAY",
            "event" : "",
            "title" : "Product ID",
            "value" : ""
        }, {
            "" : "1",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Quantity",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "quantity",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditOrderItem_quantity",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "999",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Unit Price",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "unitPrice",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditOrderItem_unitPrice",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "Kwikstore Growth",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "itemDescription",
            "type" : "TEXT",
            "action" : "",
            "disabled" : false,
            "id" : "EditOrderItem_itemDescription",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        } ],
        "target" : ""

    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "orderAdjustmentId", "orderAdjustmentTypeId", "comments", "description", "amount" ]
        } ],
        "columns" : [ {
            "name" : "orderAdjustmentId",
            "title" : "Order Adjustment ID"
        }, {
            "name" : "orderAdjustmentTypeId",
            "title" : "Adjustment Type ID"
        }, {
            "name" : "amount",
            "title" : "Amount"
        } ],
        "formName" : "EditOrderAdjustments",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/OrderViewForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "orderId",
            "action" : "",
            "id" : "EditOrderAdjustments_orderId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : "WSCO10731"
        }, {
            "conditionGroup" : "",
            "name" : "comments",
            "action" : "",
            "id" : "EditOrderAdjustments_comments",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "description",
            "action" : "",
            "id" : "EditOrderAdjustments_description",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "orderAdjustmentId",
            "description" : "",
            "style" : "",
            "id" : "EditOrderAdjustments_orderAdjustmentId",
            "title" : "Order Adjustment ID",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "orderAdjustmentTypeId",
            "description" : "",
            "style" : "",
            "id" : "EditOrderAdjustments_orderAdjustmentTypeId",
            "title" : "Adjustment Type ID",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Amount",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "amount",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditOrderAdjustments_amount",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "orderAdjustmentId", "orderAdjustmentTypeId", "comments", "description", "amount" ]
        } ],
        "formName" : "EditOrderAdjustment",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/OrderViewForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "orderAdjustmentTypeId",
            "action" : "",
            "id" : "EditOrderAdjustment_orderAdjustmentTypeId",
            "type" : "DISPLAY_ENTITY",
            "event" : "",
            "value" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "orderAdjustmentId",
            "description" : "",
            "style" : "",
            "id" : "EditOrderAdjustment_orderAdjustmentId",
            "title" : "Order Adjustment ID",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "orderAdjustmentTypeId",
            "description" : "",
            "style" : "",
            "id" : "EditOrderAdjustment_orderAdjustmentTypeId",
            "title" : "Adjustment Type ID",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Comments",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "comments",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditOrderAdjustment_comments",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Description",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "description",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditOrderAdjustment_description",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Amount",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "amount",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditOrderAdjustment_amount",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        } ],
        "target" : "updateOrderAdjustment"

    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "orderId", "paymentMethodTypeId", "maxAmount", "statusId" ]
        } ],
        "columns" : [ {
            "name" : "orderPaymentPreferenceId",
            "title" : "Order Payment Preference ID"
        }, {
            "name" : "paymentMethodTypeId",
            "title" : "Payment Method Type ID"
        }, {
            "name" : "maxAmount",
            "title" : "Max Amount"
        }, {
            "name" : "statusId",
            "title" : "Status ID"
        } ],
        "formName" : "PaymentsListMaster",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/OrderViewForms.xml",
        "type" : "list",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "orderId",
            "action" : "",
            "id" : "PaymentsListMaster_orderId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : "WSCO10731"
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "orderPaymentPreferenceId",
            "description" : "",
            "style" : "",
            "id" : "PaymentsListMaster_orderPaymentPreferenceId",
            "title" : "Order Payment Preference ID",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "paymentMethodTypeId",
            "description" : "",
            "style" : "",
            "id" : "PaymentsListMaster_paymentMethodTypeId",
            "title" : "Payment Method Type ID",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "maxAmount",
            "description" : "",
            "style" : "",
            "id" : "PaymentsListMaster_maxAmount",
            "title" : "Max Amount",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "statusId",
            "description" : "",
            "style" : "",
            "id" : "PaymentsListMaster_statusId",
            "title" : "Status ID",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "statusId", "createdDate", "orderId", "paymentMethodId", "paymentMethodTypeId", "maxAmount", "orderItemSeqId", "shipGroupSeqId", "productPricePurposeId", "finAccountId" ]
        } ],
        "formName" : "EditOrderPaymentPreference",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/OrderViewForms.xml",
        "type" : "single",
        "fields" : [ {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "orderPaymentPreferenceId",
            "description" : "",
            "style" : "",
            "id" : "EditOrderPaymentPreference_orderPaymentPreferenceId",
            "title" : "Order Payment Preference ID",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "statusId",
            "description" : "",
            "style" : "",
            "id" : "EditOrderPaymentPreference_statusId",
            "title" : "Status ID",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "createdDate",
            "description" : "",
            "style" : "",
            "id" : "EditOrderPaymentPreference_createdDate",
            "title" : "Created Date",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "paymentMethodId",
            "description" : "",
            "style" : "",
            "id" : "EditOrderPaymentPreference_paymentMethodId",
            "title" : "Payment Method ID",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "paymentMethodTypeId",
            "description" : "",
            "style" : "",
            "id" : "EditOrderPaymentPreference_paymentMethodTypeId",
            "title" : "Payment Method Type ID",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "maxAmount",
            "description" : "",
            "style" : "",
            "id" : "EditOrderPaymentPreference_maxAmount",
            "title" : "Max Amount",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "orderItemSeqId",
            "description" : "",
            "style" : "",
            "id" : "EditOrderPaymentPreference_orderItemSeqId",
            "title" : "Order Item Seq ID",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "shipGroupSeqId",
            "description" : "",
            "style" : "",
            "id" : "EditOrderPaymentPreference_shipGroupSeqId",
            "title" : "Ship Group Seq ID",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productPricePurposeId",
            "description" : "",
            "style" : "",
            "id" : "EditOrderPaymentPreference_productPricePurposeId",
            "title" : "Product Price Purpose ID",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "finAccountId",
            "description" : "",
            "style" : "",
            "id" : "EditOrderPaymentPreference_finAccountId",
            "title" : "Fin Account ID",
            "type" : "DISPLAY",
            "imageLocation" : ""
        } ],
        "target" : "updateOrderPaymentPrefernce"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "partyId", "fromDate", "address1", "address2", "city", "postalCode", "countryGeoId", "stateProvinceGeoId" ]
        } ],
        "formName" : "EditOrderPostalAddress",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/OrderViewForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "contactMechId",
            "action" : "",
            "id" : "EditOrderPostalAddress_contactMechId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : "10221"
        }, {
            "conditionGroup" : "",
            "name" : "partyId",
            "action" : "",
            "id" : "EditOrderPostalAddress_partyId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "fromDate",
            "action" : "",
            "id" : "EditOrderPostalAddress_fromDate",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "" : "93 Papilon, 24 Farm Road",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "required",
            "title" : "Address Line 1",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "address1",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditOrderPostalAddress_address1",
            "placeholder" : "",
            "event" : "",
            "value" : "93 Papilon, 24 Farm Road",
            "mask" : ""
        }, {
            "" : "Equestria",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "required",
            "title" : "Address Line 2",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "address2",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditOrderPostalAddress_address2",
            "placeholder" : "",
            "event" : "",
            "value" : "Equestria",
            "mask" : ""
        }, {
            "" : "Pretoria",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "required",
            "title" : "City",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "city",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditOrderPostalAddress_city",
            "placeholder" : "",
            "event" : "",
            "value" : "Pretoria",
            "mask" : ""
        }, {
            "" : "0001",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Zip/Postal Code",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "postalCode",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditOrderPostalAddress_postalCode",
            "placeholder" : "",
            "event" : "",
            "value" : "0001",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "required",
            "title" : "Country",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditOrderPostalAddress",
            "options" : [ {
            "description" : "ABW: Aruba",
            "key" : "ABW"
            }, {
            "description" : "AFG: Afghanistan",
            "key" : "AFG"
            }, {
            "description" : "AGO: Angola",
            "key" : "AGO"
            }, {
            "description" : "AIA: Anguilla",
            "key" : "AIA"
            }, {
            "description" : "ALA: Åland islands",
            "key" : "ALA"
            }, {
            "description" : "ALB: Albania",
            "key" : "ALB"
            }, {
            "description" : "AND: Andorra",
            "key" : "AND"
            }, {
            "description" : "ANT: Netherlands Antilles",
            "key" : "ANT"
            }, {
            "description" : "ARE: United Arab Emirates",
            "key" : "ARE"
            }, {
            "description" : "ARG: Argentina",
            "key" : "ARG"
            }, {
            "description" : "ARM: Armenia",
            "key" : "ARM"
            }, {
            "description" : "ASM: American Samoa",
            "key" : "ASM"
            }, {
            "description" : "ATA: Antarctica",
            "key" : "ATA"
            }, {
            "description" : "ATF: French Southern Territories",
            "key" : "ATF"
            }, {
            "description" : "ATG: Antigua And Barbuda",
            "key" : "ATG"
            }, {
            "description" : "AUS: Australia",
            "key" : "AUS"
            }, {
            "description" : "AUT: Austria",
            "key" : "AUT"
            }, {
            "description" : "AZE: Azerbaijan",
            "key" : "AZE"
            }, {
            "description" : "BDI: Burundi",
            "key" : "BDI"
            }, {
            "description" : "BEL: Belgium",
            "key" : "BEL"
            }, {
            "description" : "BEN: Benin",
            "key" : "BEN"
            }, {
            "description" : "BES: Bonaire, Sint Eustatius and Saba",
            "key" : "BES"
            }, {
            "description" : "BFA: Burkina Faso",
            "key" : "BFA"
            }, {
            "description" : "BGD: Bangladesh",
            "key" : "BGD"
            }, {
            "description" : "BGR: Bulgaria",
            "key" : "BGR"
            }, {
            "description" : "BHR: Bahrain",
            "key" : "BHR"
            }, {
            "description" : "BHS: Bahamas",
            "key" : "BHS"
            }, {
            "description" : "BIH: Bosnia And Herzegowina",
            "key" : "BIH"
            }, {
            "description" : "BLM: Saint Barthélemy",
            "key" : "BLM"
            }, {
            "description" : "BLR: Belarus",
            "key" : "BLR"
            }, {
            "description" : "BLZ: Belize",
            "key" : "BLZ"
            }, {
            "description" : "BMU: Bermuda",
            "key" : "BMU"
            }, {
            "description" : "BOL: Bolivia",
            "key" : "BOL"
            }, {
            "description" : "BRA: Brazil",
            "key" : "BRA"
            }, {
            "description" : "BRB: Barbados",
            "key" : "BRB"
            }, {
            "description" : "BRN: Brunei Darussalam",
            "key" : "BRN"
            }, {
            "description" : "BTN: Bhutan",
            "key" : "BTN"
            }, {
            "description" : "BVT: Bouvet Island",
            "key" : "BVT"
            }, {
            "description" : "BWA: Botswana ",
            "key" : "BWA"
            }, {
            "description" : "CAF: Central African Republic",
            "key" : "CAF"
            }, {
            "description" : "CAN: Canada",
            "key" : "CAN"
            }, {
            "description" : "CCK: Cocos (keeling) Islands",
            "key" : "CCK"
            }, {
            "description" : "CHE: Switzerland",
            "key" : "CHE"
            }, {
            "description" : "CHL: Chile",
            "key" : "CHL"
            }, {
            "description" : "CHN: China",
            "key" : "CHN"
            }, {
            "description" : "CIV: Cote D\\'ivoire",
            "key" : "CIV"
            }, {
            "description" : "CMR: Cameroon",
            "key" : "CMR"
            }, {
            "description" : "COD: Congo, The Democratic Republic Of The",
            "key" : "COD"
            }, {
            "description" : "COG: Congo",
            "key" : "COG"
            }, {
            "description" : "COK: Cook Islands",
            "key" : "COK"
            }, {
            "description" : "COL: Colombia",
            "key" : "COL"
            }, {
            "description" : "COM: Comoros",
            "key" : "COM"
            }, {
            "description" : "CPV: Cape Verde",
            "key" : "CPV"
            }, {
            "description" : "CRI: Costa Rica",
            "key" : "CRI"
            }, {
            "description" : "CUB: Cuba",
            "key" : "CUB"
            }, {
            "description" : "CUW: Curaçao",
            "key" : "CUW"
            }, {
            "description" : "CXR: Christmas Island",
            "key" : "CXR"
            }, {
            "description" : "CYM: Cayman Islands",
            "key" : "CYM"
            }, {
            "description" : "CYP: Cyprus",
            "key" : "CYP"
            }, {
            "description" : "CZE: Czech Republic",
            "key" : "CZE"
            }, {
            "description" : "DEU: Germany",
            "key" : "DEU"
            }, {
            "description" : "DJI: Djibouti",
            "key" : "DJI"
            }, {
            "description" : "DMA: Dominica",
            "key" : "DMA"
            }, {
            "description" : "DNK: Denmark",
            "key" : "DNK"
            }, {
            "description" : "DOM: Dominican Republic",
            "key" : "DOM"
            }, {
            "description" : "DZA: Algeria",
            "key" : "DZA"
            }, {
            "description" : "ECU: Ecuador",
            "key" : "ECU"
            }, {
            "description" : "EGY: Egypt",
            "key" : "EGY"
            }, {
            "description" : "ENGL: England",
            "key" : "ENGL"
            }, {
            "description" : "ERI: Eritrea",
            "key" : "ERI"
            }, {
            "description" : "ESH: Western Sahara",
            "key" : "ESH"
            }, {
            "description" : "ESP: Spain",
            "key" : "ESP"
            }, {
            "description" : "EST: Estonia",
            "key" : "EST"
            }, {
            "description" : "ETH: Ethiopia",
            "key" : "ETH"
            }, {
            "description" : "FIN: Finland",
            "key" : "FIN"
            }, {
            "description" : "FJI: Fiji",
            "key" : "FJI"
            }, {
            "description" : "FLK: Falkland Islands (malvinas)",
            "key" : "FLK"
            }, {
            "description" : "FRA: France",
            "key" : "FRA"
            }, {
            "description" : "FRO: Faroe Islands",
            "key" : "FRO"
            }, {
            "description" : "FSM: Micronesia, Federated States Of",
            "key" : "FSM"
            }, {
            "description" : "FXX: France, Metropolitan",
            "key" : "FXX"
            }, {
            "description" : "GAB: Gabon",
            "key" : "GAB"
            }, {
            "description" : "GBR: United Kingdom",
            "key" : "GBR"
            }, {
            "description" : "GEO: Georgia",
            "key" : "GEO"
            }, {
            "description" : "GGY: Guernsey",
            "key" : "GGY"
            }, {
            "description" : "GHA: Ghana",
            "key" : "GHA"
            }, {
            "description" : "GIB: Gibraltar",
            "key" : "GIB"
            }, {
            "description" : "GIN: Guinea",
            "key" : "GIN"
            }, {
            "description" : "GLP: Guadeloupe",
            "key" : "GLP"
            }, {
            "description" : "GMB: Gambia",
            "key" : "GMB"
            }, {
            "description" : "GNB: Guinea-bissau",
            "key" : "GNB"
            }, {
            "description" : "GNQ: Equatorial Guinea",
            "key" : "GNQ"
            }, {
            "description" : "GRC: Greece",
            "key" : "GRC"
            }, {
            "description" : "GRD: Grenada",
            "key" : "GRD"
            }, {
            "description" : "GRL: Greenland",
            "key" : "GRL"
            }, {
            "description" : "GTM: Guatemala",
            "key" : "GTM"
            }, {
            "description" : "GUF: French Guiana",
            "key" : "GUF"
            }, {
            "description" : "GUM: Guam",
            "key" : "GUM"
            }, {
            "description" : "GUY: Guyana",
            "key" : "GUY"
            }, {
            "description" : "HKG: Hong Kong",
            "key" : "HKG"
            }, {
            "description" : "HMD: Heard And Mc Donald Islands",
            "key" : "HMD"
            }, {
            "description" : "HND: Honduras",
            "key" : "HND"
            }, {
            "description" : "HRV: Croatia (local Name: Hrvatska)",
            "key" : "HRV"
            }, {
            "description" : "HTI: Haiti",
            "key" : "HTI"
            }, {
            "description" : "HUN: Hungary",
            "key" : "HUN"
            }, {
            "description" : "IDN: Indonesia",
            "key" : "IDN"
            }, {
            "description" : "IMN: Isle of Man",
            "key" : "IMN"
            }, {
            "description" : "IND: India",
            "key" : "IND"
            }, {
            "description" : "IOT: British Indian Ocean Territory",
            "key" : "IOT"
            }, {
            "description" : "IRL: Ireland",
            "key" : "IRL"
            }, {
            "description" : "IRN: Iran (islamic Republic Of)",
            "key" : "IRN"
            }, {
            "description" : "IRQ: Iraq",
            "key" : "IRQ"
            }, {
            "description" : "ISL: Iceland",
            "key" : "ISL"
            }, {
            "description" : "ISR: Israel",
            "key" : "ISR"
            }, {
            "description" : "ITA: Italy",
            "key" : "ITA"
            }, {
            "description" : "JAM: Jamaica",
            "key" : "JAM"
            }, {
            "description" : "JEY: Jersey",
            "key" : "JEY"
            }, {
            "description" : "JOR: Jordan",
            "key" : "JOR"
            }, {
            "description" : "JPN: Japan",
            "key" : "JPN"
            }, {
            "description" : "KAZ: Kazakhstan",
            "key" : "KAZ"
            }, {
            "description" : "KEN: Kenya",
            "key" : "KEN"
            }, {
            "description" : "KGZ: Kyrgyzstan",
            "key" : "KGZ"
            }, {
            "description" : "KHM: Cambodia",
            "key" : "KHM"
            }, {
            "description" : "KIR: Kiribati",
            "key" : "KIR"
            }, {
            "description" : "KNA: Saint Kitts And Nevis",
            "key" : "KNA"
            }, {
            "description" : "KOR: Korea, Republic Of",
            "key" : "KOR"
            }, {
            "description" : "KWT: Kuwait",
            "key" : "KWT"
            }, {
            "description" : "LAO: Lao People\\'s Democratic Republic",
            "key" : "LAO"
            }, {
            "description" : "LBN: Lebanon",
            "key" : "LBN"
            }, {
            "description" : "LBR: Liberia",
            "key" : "LBR"
            }, {
            "description" : "LBY: Libyan Arab Jamahiriya",
            "key" : "LBY"
            }, {
            "description" : "LCA: Saint Lucia",
            "key" : "LCA"
            }, {
            "description" : "LIE: Liechtenstein",
            "key" : "LIE"
            }, {
            "description" : "LKA: Sri Lanka",
            "key" : "LKA"
            }, {
            "description" : "LSO: Lesotho",
            "key" : "LSO"
            }, {
            "description" : "LTU: Lithuania",
            "key" : "LTU"
            }, {
            "description" : "LUX: Luxembourg",
            "key" : "LUX"
            }, {
            "description" : "LVA: Latvia",
            "key" : "LVA"
            }, {
            "description" : "MAC: Macau",
            "key" : "MAC"
            }, {
            "description" : "MAF: Saint Martin (French part)",
            "key" : "MAF"
            }, {
            "description" : "MAR: Morocco",
            "key" : "MAR"
            }, {
            "description" : "MCO: Monaco",
            "key" : "MCO"
            }, {
            "description" : "MDA: Moldova, Republic Of",
            "key" : "MDA"
            }, {
            "description" : "MDG: Madagascar",
            "key" : "MDG"
            }, {
            "description" : "MDV: Maldives",
            "key" : "MDV"
            }, {
            "description" : "MEX: Mexico",
            "key" : "MEX"
            }, {
            "description" : "MHL: Marshall Islands",
            "key" : "MHL"
            }, {
            "description" : "MKD: Macedonia, The Former Yugoslav Republic Of",
            "key" : "MKD"
            }, {
            "description" : "MLI: Mali",
            "key" : "MLI"
            }, {
            "description" : "MLT: Malta",
            "key" : "MLT"
            }, {
            "description" : "MMR: Myanmar",
            "key" : "MMR"
            }, {
            "description" : "MNE: Montenegro",
            "key" : "MNE"
            }, {
            "description" : "MNG: Mongolia",
            "key" : "MNG"
            }, {
            "description" : "MNP: Northern Mariana Islands",
            "key" : "MNP"
            }, {
            "description" : "MOZ: Mozambique",
            "key" : "MOZ"
            }, {
            "description" : "MRT: Mauritania",
            "key" : "MRT"
            }, {
            "description" : "MSR: Montserrat",
            "key" : "MSR"
            }, {
            "description" : "MTQ: Martinique",
            "key" : "MTQ"
            }, {
            "description" : "MUS: Mauritius",
            "key" : "MUS"
            }, {
            "description" : "MWI: Malawi",
            "key" : "MWI"
            }, {
            "description" : "MYS: Malaysia",
            "key" : "MYS"
            }, {
            "description" : "MYT: Mayotte",
            "key" : "MYT"
            }, {
            "description" : "NAM: Namibia",
            "key" : "NAM"
            }, {
            "description" : "NCL: New Caledonia",
            "key" : "NCL"
            }, {
            "description" : "NER: Niger",
            "key" : "NER"
            }, {
            "description" : "NFK: Norfolk Island",
            "key" : "NFK"
            }, {
            "description" : "NGA: Nigeria",
            "key" : "NGA"
            }, {
            "description" : "NIC: Nicaragua",
            "key" : "NIC"
            }, {
            "description" : "NIRL: NIRL",
            "key" : "NIRL"
            }, {
            "description" : "NIU: Niue",
            "key" : "NIU"
            }, {
            "description" : "NLD: Netherlands",
            "key" : "NLD"
            }, {
            "description" : "NOR: Norway",
            "key" : "NOR"
            }, {
            "description" : "NPL: Nepal",
            "key" : "NPL"
            }, {
            "description" : "NRU: Nauru",
            "key" : "NRU"
            }, {
            "description" : "NZL: New Zealand",
            "key" : "NZL"
            }, {
            "description" : "OMN: Oman",
            "key" : "OMN"
            }, {
            "description" : "PAK: Pakistan",
            "key" : "PAK"
            }, {
            "description" : "PAN: Panama",
            "key" : "PAN"
            }, {
            "description" : "PCN: Pitcairn",
            "key" : "PCN"
            }, {
            "description" : "PER: Peru",
            "key" : "PER"
            }, {
            "description" : "PHL: Philippines",
            "key" : "PHL"
            }, {
            "description" : "PLW: Palau",
            "key" : "PLW"
            }, {
            "description" : "PNG: Papua New Guinea",
            "key" : "PNG"
            }, {
            "description" : "POL: Poland",
            "key" : "POL"
            }, {
            "description" : "PRI: Puerto Rico",
            "key" : "PRI"
            }, {
            "description" : "PRK: Korea, Democratic People\\'s Republic Of",
            "key" : "PRK"
            }, {
            "description" : "PRT: Portugal",
            "key" : "PRT"
            }, {
            "description" : "PRY: Paraguay",
            "key" : "PRY"
            }, {
            "description" : "PSE: Palestinian Territory, Occupied",
            "key" : "PSE"
            }, {
            "description" : "PYF: French Polynesia",
            "key" : "PYF"
            }, {
            "description" : "QAT: Qatar",
            "key" : "QAT"
            }, {
            "description" : "REU: Reunion",
            "key" : "REU"
            }, {
            "description" : "ROU: Romania",
            "key" : "ROU"
            }, {
            "description" : "RUS: Russian Federation",
            "key" : "RUS"
            }, {
            "description" : "RWA: Rwanda",
            "key" : "RWA"
            }, {
            "description" : "SAU: Saudi Arabia",
            "key" : "SAU"
            }, {
            "description" : "SCOT: Scotland",
            "key" : "SCOT"
            }, {
            "description" : "SDN: Sudan",
            "key" : "SDN"
            }, {
            "description" : "SEN: Senegal",
            "key" : "SEN"
            }, {
            "description" : "SGP: Singapore",
            "key" : "SGP"
            }, {
            "description" : "SGS: South Georgia And The South Sandwich Islands",
            "key" : "SGS"
            }, {
            "description" : "SHN: St. Helena",
            "key" : "SHN"
            }, {
            "description" : "SJM: Svalbard And Jan Mayen Islands",
            "key" : "SJM"
            }, {
            "description" : "SLB: Solomon Islands",
            "key" : "SLB"
            }, {
            "description" : "SLE: Sierra Leone",
            "key" : "SLE"
            }, {
            "description" : "SLV: El Salvador",
            "key" : "SLV"
            }, {
            "description" : "SMR: San Marino",
            "key" : "SMR"
            }, {
            "description" : "SOM: Somalia",
            "key" : "SOM"
            }, {
            "description" : "SPM: St. Pierre And Miquelon",
            "key" : "SPM"
            }, {
            "description" : "SRB: Serbia",
            "key" : "SRB"
            }, {
            "description" : "SSD: South Sudan",
            "key" : "SSD"
            }, {
            "description" : "STP: Sao Tome And Principe",
            "key" : "STP"
            }, {
            "description" : "SUR: Suriname",
            "key" : "SUR"
            }, {
            "description" : "SVK: Slovakia (slovak Republic)",
            "key" : "SVK"
            }, {
            "description" : "SVN: Slovenia",
            "key" : "SVN"
            }, {
            "description" : "SWE: Sweden",
            "key" : "SWE"
            }, {
            "description" : "SWZ: Swaziland",
            "key" : "SWZ"
            }, {
            "description" : "SXM: Sint Maarten (Dutch part)",
            "key" : "SXM"
            }, {
            "description" : "SYC: Seychelles",
            "key" : "SYC"
            }, {
            "description" : "SYR: Syrian Arab Republic",
            "key" : "SYR"
            }, {
            "description" : "TCA: Turks And Caicos Islands",
            "key" : "TCA"
            }, {
            "description" : "TCD: Chad",
            "key" : "TCD"
            }, {
            "description" : "TGO: Togo",
            "key" : "TGO"
            }, {
            "description" : "THA: Thailand",
            "key" : "THA"
            }, {
            "description" : "TJK: Tajikistan",
            "key" : "TJK"
            }, {
            "description" : "TKL: Tokelau",
            "key" : "TKL"
            }, {
            "description" : "TKM: Turkmenistan",
            "key" : "TKM"
            }, {
            "description" : "TLS: East Timor",
            "key" : "TLS"
            }, {
            "description" : "TON: Tonga",
            "key" : "TON"
            }, {
            "description" : "TTO: Trinidad And Tobago",
            "key" : "TTO"
            }, {
            "description" : "TUN: Tunisia",
            "key" : "TUN"
            }, {
            "description" : "TUR: Turkey",
            "key" : "TUR"
            }, {
            "description" : "TUV: Tuvalu",
            "key" : "TUV"
            }, {
            "description" : "TWN: Taiwan",
            "key" : "TWN"
            }, {
            "description" : "TZA: Tanzania, United Republic Of",
            "key" : "TZA"
            }, {
            "description" : "UGA: Uganda",
            "key" : "UGA"
            }, {
            "description" : "UKR: Ukraine",
            "key" : "UKR"
            }, {
            "description" : "UMI: United States Minor Outlying Islands",
            "key" : "UMI"
            }, {
            "description" : "URY: Uruguay",
            "key" : "URY"
            }, {
            "description" : "USA: United States",
            "key" : "USA"
            }, {
            "description" : "UZB: Uzbekistan",
            "key" : "UZB"
            }, {
            "description" : "VAT: Holy See (vatican City State)",
            "key" : "VAT"
            }, {
            "description" : "VCT: Saint Vincent And The Grenadines",
            "key" : "VCT"
            }, {
            "description" : "VEN: Venezuela",
            "key" : "VEN"
            }, {
            "description" : "VGB: Virgin Islands (british)",
            "key" : "VGB"
            }, {
            "description" : "VIR: Virgin Islands (u.s.)",
            "key" : "VIR"
            }, {
            "description" : "VNM: Viet Nam",
            "key" : "VNM"
            }, {
            "description" : "VUT: Vanuatu",
            "key" : "VUT"
            }, {
            "description" : "WALS: WALS",
            "key" : "WALS"
            }, {
            "description" : "WLF: Wallis And Futuna Islands",
            "key" : "WLF"
            }, {
            "description" : "WSM: Samoa",
            "key" : "WSM"
            }, {
            "description" : "YEM: Yemen",
            "key" : "YEM"
            }, {
            "description" : "YUG: Yugoslavia",
            "key" : "YUG"
            }, {
            "description" : "ZAF: South Africa",
            "key" : "ZAF"
            }, {
            "description" : "ZMB: Zambia",
            "key" : "ZMB"
            }, {
            "description" : "ZWE: Zimbabwe",
            "key" : "ZWE"
            } ],
            "disabled" : "false",
            "id" : "EditOrderPostalAddress_countryGeoId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "countryGeoId",
            "style" : "",
            "explicitDescription" : "ZAF: South Africa",
            "choices" : "",
            "currentValue" : "ZAF"
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "required",
            "title" : "State",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "EditOrderPostalAddress",
            "options" : [ ],
            "disabled" : "false",
            "id" : "EditOrderPostalAddress_stateProvinceGeoId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "stateProvinceGeoId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        } ],
        "target" : "updatePostalAddress"

    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "contactMechId" ]
        } ],
        "formName" : "EditOrderEmailAddress",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/OrderViewForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "contactMechId",
            "action" : "",
            "id" : "EditOrderEmailAddress_contactMechId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "" : "kwikstore@gmail.com",
            "fieldHelpText" : "",
            "textSize" : "25",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Email Address",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "infoString",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "EditOrderEmailAddress_infoString",
            "placeholder" : "",
            "event" : "",
            "value" : "kwikstore@gmail.com",
            "mask" : ""
        }],
        "target" : "updateEmailAddress"
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "contactMechId" ]
        } ],
        "columns" : [ {
            "name" : "contactMechPurposeTypeId",
            "title" : "ContactMech Purpose"
        }, {
            "name" : "contactMechId",
            "title" : "Contact Mech ID"
        } ],
        "formName" : "ContactMechMasterList",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/OrderViewForms.xml",
        "type" : "list",
        "fields" : [ {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "contactMechPurposeTypeId",
            "description" : "",
            "style" : "",
            "id" : "ContactMechMasterList_contactMechPurposeTypeId",
            "title" : "ContactMech Purpose",
            "type" : "DISPLAY_ENTITY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "contactMechId",
            "description" : "",
            "style" : "",
            "id" : "ContactMechMasterList_contactMechId",
            "title" : "Contact Mech ID",
            "type" : "DISPLAY",
            "imageLocation" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "orderId", "orderName", "orderType", "billTo", "partyId", "billFrom", "storeName", "amount", "trackingCode", "statusId", "inventoryProblems", "authorisation", "pastETA", "rejectedItems", "partiallyReceived" ]
        } ],
        "columns" : [ {
            "name" : "orderDate",
            "title" : "Date"
        }, {
            "name" : "orderId",
            "title" : "Order ID"
        }, {
            "name" : "orderName",
            "title" : "Order Name"
        }, {
            "name" : "orderType",
            "title" : "Type"
        }, {
            "name" : "billTo",
            "title" : "Bill T0"
        }, {
            "name" : "partyId",
            "title" : "Party ID"
        }, {
            "name" : "billFrom",
            "title" : "Bill From"
        }, {
            "name" : "storeName",
            "title" : "Store Name"
        }, {
            "name" : "amount",
            "title" : "Amount"
        }, {
            "name" : "trackingCode",
            "title" : "Tracking Code"
        }, {
            "name" : "statusId",
            "title" : "Status"
        }, {
            "name" : "inventoryProblems",
            "title" : "Inventory Problems"
        }, {
            "name" : "authorisation",
            "title" : "Authorisation"
        }, {
            "name" : "pastETA",
            "title" : "Past E T A"
        }, {
            "name" : "rejectedItems",
            "title" : "Rejected Items"
        }, {
            "name" : "partiallyReceived",
            "title" : "Partially Received"
        } ],
        "formName" : "PartyOrders",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/OrderForms.xml",
        "type" : "list",
        "fields" : [ {
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "orderDate",
            "description" : "",
            "id" : "OrderList_orderDate",
            "type" : "DISPLAY",
            "title" : "Data",
            "imageLocation" : ""
        }, {
            "image" : "",
            "width" : "",
            "name" : "orderId",
            "alternate" : "",
            "description" : "",
            "parameterList" : [ {
            "name" : "orderId"
            } ],
            "id" : "OrderList_orderId",
            "imageTitle" : "",
            "parameterMap" : { },
            "height" : "",
            "target" : "orderview"
        }, {
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "orderName",
            "description" : "",
            "id" : "OrderList_orderName",
            "type" : "HIDDEN",
            "title" : "",
            "imageLocation" : ""
        }, {
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "orderType",
            "description" : "",
            "id" : "OrderList_orderType",
            "type" : "HIDDEN",
            "title" : "",
            "imageLocation" : ""
        }, {
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "billTo",
            "description" : "",
            "id" : "OrderList_billTo",
            "type" : "HIDDEN",
            "title" : "",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "partyId",
            "description" : "",
            "style" : "",
            "id" : "OrderList_partyId",
            "title" : "Party ID",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "billFrom",
            "description" : "",
            "id" : "OrderList_billFrom",
            "type" : "HIDDEN",
            "title" : "",
            "imageLocation" : ""
        }, {
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "storeName",
            "description" : "",
            "id" : "OrderList_storeName",
            "type" : "DISPLAY",
            "title" : "",
            "imageLocation" : ""
        }, {
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "amount",
            "description" : "",
            "id" : "OrderList_amount",
            "type" : "DISPLAY",
            "title" : "",
            "imageLocation" : ""
        }, {
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "trackingCode",
            "description" : "",
            "id" : "OrderList_trackingCode",
            "type" : "HIDDEN",
            "title" : "",
            "imageLocation" : ""
        }, {
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "statusId",
            "description" : "",
            "id" : "OrderList_statusId",
            "type" : "DISPLAY_ENTITY",
            "title" : "",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "inventoryProblems",
            "description" : "",
            "style" : "",
            "id" : "OrderList_inventoryProblems",
            "title" : "Inventory Problems",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "authorisation",
            "description" : "",
            "style" : "",
            "id" : "OrderList_authorisation",
            "title" : "Authorisation",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "pastETA",
            "description" : "",
            "style" : "",
            "id" : "OrderList_pastETA",
            "title" : "Past E T A",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "rejectedItems",
            "description" : "",
            "style" : "",
            "id" : "OrderList_rejectedItems",
            "title" : "Rejected Items",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "partiallyReceived",
            "description" : "",
            "style" : "",
            "id" : "OrderList_partiallyReceived",
            "title" : "Partially Received",
            "type" : "HIDDEN",
            "imageLocation" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "orderItemSeqId", "productId", "itemDescription", "requiredQuantity", "qohQuantityByFacility", "atpQuantityByFacility", "qohQuantity", "atpQuantity", "onOrderQuantity", "inProductionQuantity", "unplannedQuantity", "reserveAfterDate", "currentItemStatus", "quantity", "itemReservedQuantity", "cancelQuantity", "pickedQty", "remainingQuantity", "shippedQuantity", "shortfalledQuantity", "orderInvoiced", "orderReturned", "unitPrice", "unitListPrice", "adjustments", "subTotal" ]
        } ],
        "columns" : [ {
            "name" : "orderId",
            "title" : "Order ID"
        }, {
            "name" : "orderItemSeqId",
            "title" : "Order Item Seq ID"
        }, {
            "name" : "productId",
            "title" : "Product ID"
        }, {
            "name" : "itemDescription",
            "title" : "Description"
        }, {
            "name" : "requiredQuantity",
            "title" : "Required for SO"
        }, {
            "name" : "qohQuantityByFacility",
            "title" : "In Inventory [] QOH"
        }, {
            "name" : "atpQuantityByFacility",
            "title" : "ATP"
        }, {
            "name" : "qohQuantity",
            "title" : "In Inventory [All Facilities] QOH"
        }, {
            "name" : "atpQuantity",
            "title" : "ATP"
        }, {
            "name" : "onOrderQuantity",
            "title" : "On Order"
        }, {
            "name" : "inProductionQuantity",
            "title" : "In Production"
        }, {
            "name" : "unplannedQuantity",
            "title" : "Unplanned"
        }, {
            "name" : "reserveAfterDate",
            "title" : "Reserve After Date"
        }, {
            "name" : "currentItemStatus",
            "title" : "Current Item Status"
        }, {
            "name" : "quantity",
            "title" : "Ordered"
        }, {
            "name" : "itemReservedQuantity",
            "title" : "Ship Request"
        }, {
            "name" : "cancelQuantity",
            "title" : "Cancelled"
        }, {
            "name" : "pickedQty",
            "title" : "Qty Picked"
        }, {
            "name" : "remainingQuantity",
            "title" : "Remaining"
        }, {
            "name" : "shippedQuantity",
            "title" : "Qty Shipped"
        }, {
            "name" : "shortfalledQuantity",
            "title" : "Shortfalled"
        }, {
            "name" : "orderInvoiced",
            "title" : "Invoiced"
        }, {
            "name" : "orderReturned",
            "title" : "Returned"
        }, {
            "name" : "unitPrice",
            "title" : "Item Unit Price"
        }, {
            "name" : "unitListPrice",
            "title" : "Item Unit List Price"
        }, {
            "name" : "adjustments",
            "title" : "Item Adjustments"
        }, {
            "name" : "subTotal",
            "title" : "Sub Total"
        } ],
        "formName" : "OrderItems",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/OrderViewForms.xml",
        "type" : "list",
        "fields" : [ {
            name:"details",
            title:"Details",
            type:"COMPOSITE",
            innerFields:[
                {
                    name:"orderItemSeqId",
                    title:"Order Item Seq ID"
                },
                {
                    name:"productId",
                    title:"Product ID"
                },
                {
                    name:"itemDescription",
                    title:"Description"
                },
                {
                    name:"currentItemStatus",
                    title:"Current Item Status"
                },
                {
                    name:"quantity",
                    title:"Ordered"
                },
                {
                    name:"shippedQuantity",
                    title:"Qty Shipped"
                },
                {
                    name:"orderInvoiced",
                    title:"Invoiced"
                },
                {
                    name:"orderReturned",
                    title:"Returned"
                },
                {
                    name:"unitPrice",
                    title:"Item Unit Price"
                },
                {
                    name:"unitListPrice",
                    title:"Item Unit List Price"
                },
                {
                    name:"adjustments",
                    title:"Item Adjustments"
                },
                {
                    name:"subTotal",
                    title:"Sub Total"
                }
        ]
        },{
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "orderId",
            "description" : "WSCO10731",
            "style" : "",
            "id" : "OrderItems_orderId",
            "title" : "Order ID",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "orderItemSeqId",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_orderItemSeqId",
            "title" : "Order Item Seq ID",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productId",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_productId",
            "title" : "Product ID",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "itemDescription",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_itemDescription",
            "title" : "Description",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "requiredQuantity",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_requiredQuantity",
            "title" : "Required for SO",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "qohQuantityByFacility",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_qohQuantityByFacility",
            "title" : "In Inventory [] QOH",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "atpQuantityByFacility",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_atpQuantityByFacility",
            "title" : "ATP",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "qohQuantity",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_qohQuantity",
            "title" : "In Inventory [All Facilities] QOH",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "atpQuantity",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_atpQuantity",
            "title" : "ATP",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "onOrderQuantity",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_onOrderQuantity",
            "title" : "On Order",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "inProductionQuantity",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_inProductionQuantity",
            "title" : "In Production",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "unplannedQuantity",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_unplannedQuantity",
            "title" : "Unplanned",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "reserveAfterDate",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_reserveAfterDate",
            "title" : "Reserve After Date",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "currentItemStatus",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_currentItemStatus",
            "title" : "Current Item Status",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "quantity",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_quantity",
            "title" : "Ordered",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "itemReservedQuantity",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_itemReservedQuantity",
            "title" : "Ship Request",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "cancelQuantity",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_cancelQuantity",
            "title" : "Cancelled",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "pickedQty",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_pickedQty",
            "title" : "Qty Picked",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "remainingQuantity",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_remainingQuantity",
            "title" : "Remaining",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "shippedQuantity",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_shippedQuantity",
            "title" : "Qty Shipped",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "shortfalledQuantity",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_shortfalledQuantity",
            "title" : "Shortfalled",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "orderInvoiced",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_orderInvoiced",
            "title" : "Invoiced",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "orderReturned",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_orderReturned",
            "title" : "Returned",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "unitPrice",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_unitPrice",
            "title" : "Item Unit Price",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "unitListPrice",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_unitListPrice",
            "title" : "Item Unit List Price",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "adjustments",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_adjustments",
            "title" : "Item Adjustments",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "subTotal",
            "description" : "",
            "style" : "",
            "id" : "OrderItems_subTotal",
            "title" : "Sub Total",
            "type" : "HIDDEN",
            "imageLocation" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "orderItemSeqId", "estimatedReadyDate", "cartons", "skidsPallets", "unitsPieces", "totalCubicSize", "totalCubicUomId", "totalWeight", "totalWeightUomId", "statusId", "submitButton" ]
        } ],
        "formName" : "UpdateDeliveryScheduleInformation",
        "altTarget" : [ {
            "useWhen" : "schedule==null",
            "targetExdr" : {
            "chars" : "createOrderDeliverySchedule",
            "hint" : 20,
            "empty" : false,
            "original" : "createOrderDeliverySchedule"
            }
        } ],
        "formLocation" : "component://kwikstore/widget/OrderForms.xml",
        "type" : "single",
        "fields" : [ {
            "conditionGroup" : "",
            "name" : "orderId",
            "action" : "",
            "id" : "UpdateDeliveryScheduleInformation_orderId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "conditionGroup" : "",
            "name" : "orderItemSeqId",
            "action" : "",
            "id" : "UpdateDeliveryScheduleInformation_orderItemSeqId",
            "type" : "HIDDEN",
            "event" : "",
            "value" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Estimated Ready Date",
            "type" : "DATE_TIME",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2025-01-05%2006:16:29.05",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "UpdateDeliveryScheduleInformation",
            "timeDropdownParamName" : "estimatedReadyDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "UpdateDeliveryScheduleInformation_estimatedReadyDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "Format: yyyy-MM-dd HH:mm:ss.SSS",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "View Calendar",
            "timeHourName" : "",
            "name" : "estimatedReadyDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Cartons",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "cartons",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "UpdateDeliveryScheduleInformation_cartons",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Skids Pallets",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "skidsPallets",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "UpdateDeliveryScheduleInformation_skidsPallets",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Units Pieces",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "unitsPieces",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "UpdateDeliveryScheduleInformation_unitsPieces",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Total Cubic Size",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "totalCubicSize",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "UpdateDeliveryScheduleInformation_totalCubicSize",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Cubic Measurement",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "UpdateDeliveryScheduleInformation",
            "options" : [ {
            "description" : "Cubic centimeter",
            "key" : "VDRY_cm3"
            }, {
            "description" : "Cubic foot",
            "key" : "VDRY_ft3"
            }, {
            "description" : "Cubic inch",
            "key" : "VDRY_in3"
            }, {
            "description" : "Cubic meter",
            "key" : "VDRY_m3"
            }, {
            "description" : "Cubic millimeter",
            "key" : "VDRY_mm3"
            }, {
            "description" : "Stere (cubic meter)",
            "key" : "VDRY_ST"
            }, {
            "description" : "Cubic yard",
            "key" : "VDRY_yd3"
            } ],
            "disabled" : "false",
            "id" : "UpdateDeliveryScheduleInformation_totalCubicUomId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "totalCubicUomId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "6",
            "ajaxUrl" : "",
            "maxlength" : "",
            "tabindex" : "",
            "className" : "",
            "title" : "Total Weight",
            "type" : "TEXT",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "totalWeight",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "UpdateDeliveryScheduleInformation_totalWeight",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Weight Measurement",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "UpdateDeliveryScheduleInformation",
            "options" : [ {
            "description" : "Dram (avdp)",
            "key" : "WT_dr_avdp"
            }, {
            "description" : "Grain",
            "key" : "WT_gr"
            }, {
            "description" : "Gram",
            "key" : "WT_g"
            }, {
            "description" : "Kilogram",
            "key" : "WT_kg"
            }, {
            "description" : "Milligram",
            "key" : "WT_mg"
            }, {
            "description" : "Ounce (avdp)",
            "key" : "WT_oz"
            }, {
            "description" : "Ounce (troy)",
            "key" : "WT_oz_tr"
            }, {
            "description" : "Pennyweight",
            "key" : "WT_dwt"
            }, {
            "description" : "Pound (avdp)",
            "key" : "WT_lb"
            }, {
            "description" : "Stone",
            "key" : "WT_st"
            }, {
            "description" : "Ton (long or British)",
            "key" : "WT_lt"
            }, {
            "description" : "Ton (metric)",
            "key" : "WT_mt"
            }, {
            "description" : "Ton (short)",
            "key" : "WT_sh_t"
            } ],
            "disabled" : "false",
            "id" : "UpdateDeliveryScheduleInformation_totalWeightUomId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "totalWeightUomId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Status ID",
            "type" : "DROP_DOWN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "UpdateDeliveryScheduleInformation",
            "options" : [ {
            "description" : "Supplier Submitted",
            "key" : "ODS_SUBMITTED"
            }, {
            "description" : "Accepted",
            "key" : "ODS_ACCEPTED"
            }, {
            "description" : "Schedule Approved",
            "key" : "ODS_APPROVED"
            }, {
            "description" : "Delivery Arranged",
            "key" : "ODS_ARRANGED"
            }, {
            "description" : "Delivery Cancelled",
            "key" : "ODS_CANCELLED"
            } ],
            "disabled" : "false",
            "id" : "UpdateDeliveryScheduleInformation_statusId",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "selected",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "statusId",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "buttonType" : "button",
            "alert" : "false",
            "formName" : "UpdateDeliveryScheduleInformation",
            "tabindex" : "",
            "name" : "submitButton",
            "className" : "smallSubmit",
            "id" : "UpdateDeliveryScheduleInformation_submitButton",
            "confirmation" : "",
            "type" : "SUBMIT",
            "title" : "Update",
            "event" : "",
            "imgSrc" : ""
        } ],
        "target" : "updateOrderDeliverySchedule"

    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "shipGroupSeqId", "shipmentMethodTypeId", "supplierPartyId", "supplierAgreementId", "vendorPartyId", "carrierPartyId", "carrierRoleTypeId", "facilityId", "contactMechId", "telecomContactMechId", "trackingNumber", "shippingInstructions", "maySplit", "giftMessage", "isGift", "shipAfterDate", "shipByDate", "estimatedShipDate", "estimatedDeliveryDate", "address1", "address2", "city" ]
        } ],
        "columns" : [ {
            "name" : "orderId",
            "title" : "Order ID"
        }, {
            "name" : "shipGroupSeqId",
            "title" : "Ship Group Seq ID"
        }, {
            "name" : "shipmentMethodTypeId",
            "title" : "Shipment Method Type ID"
        }, {
            "name" : "supplierPartyId",
            "title" : "Supplier Party ID"
        }, {
            "name" : "supplierAgreementId",
            "title" : "Supplier Agreement ID"
        }, {
            "name" : "vendorPartyId",
            "title" : "Vendor Party ID"
        }, {
            "name" : "carrierPartyId",
            "title" : "Carrier Party ID"
        }, {
            "name" : "carrierRoleTypeId",
            "title" : "Carrier Role Type ID"
        }, {
            "name" : "facilityId",
            "title" : "Facility ID"
        }, {
            "name" : "contactMechId",
            "title" : "Contact Mech ID"
        }, {
            "name" : "telecomContactMechId",
            "title" : "Telecom Contact Mech ID"
        }, {
            "name" : "trackingNumber",
            "title" : "Tracking Number"
        }, {
            "name" : "shippingInstructions",
            "title" : "Shipping Instructions"
        }, {
            "name" : "maySplit",
            "title" : "May Split"
        }, {
            "name" : "giftMessage",
            "title" : "Gift Message"
        }, {
            "name" : "isGift",
            "title" : "Is Gift"
        }, {
            "name" : "shipAfterDate",
            "title" : "Ship After Date"
        }, {
            "name" : "shipByDate",
            "title" : "Ship By Date"
        }, {
            "name" : "estimatedShipDate",
            "title" : "Estimated Ship Date"
        }, {
            "name" : "estimatedDeliveryDate",
            "title" : "Estimated Delivery Date"
        }, {
            "name" : "address1",
            "title" : "Address1"
        }, {
            "name" : "address2",
            "title" : "Address2"
        }, {
            "name" : "city",
            "title" : "City"
        } ],
        "formName" : "ShipGroupsMaster",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/OrderViewForms.xml",
        "type" : "list",
        "fields" : [ {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "orderId",
            "description" : "WSCO10731",
            "style" : "",
            "id" : "OrderShippingInfo_orderId",
            "title" : "Order ID",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Ship Group Seq ID",
            "type" : "DISPLAY",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "shipGroupSeqId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "OrderShippingInfo_shipGroupSeqId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Shipment Method Type ID",
            "type" : "HIDDEN",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "shipmentMethodTypeId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "OrderShippingInfo_shipmentMethodTypeId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Supplier Party ID",
            "type" : "HIDDEN",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "supplierPartyId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "OrderShippingInfo_supplierPartyId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Supplier Agreement ID",
            "type" : "HIDDEN",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "supplierAgreementId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "OrderShippingInfo_supplierAgreementId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Vendor Party ID",
            "type" : "HIDDEN",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "vendorPartyId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "OrderShippingInfo_vendorPartyId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Carrier Party ID",
            "type" : "DISPLAY",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "carrierPartyId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "OrderShippingInfo_carrierPartyId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Carrier Role Type ID",
            "type" : "HIDDEN",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "carrierRoleTypeId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "OrderShippingInfo_carrierRoleTypeId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            name:"dates",
            title:"Dates",
            type:"COMPOSITE",
            innerFields:[
                {
                    name:"shipAfterDate",
                    title:"Ship After Date"
                },
                {
                    name:"shipByDate",
                    title:"Ship By Date"
                },
                {
                    name:"estimatedShipDate",
                    title:"Estimated Ship Date"
                },
                {
                    name:"estimatedDeliveryDate",
                    title:"Estimated Delivery Date"
                }
            ]
        },{
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Facility ID",
            "type" : "HIDDEN",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "facilityId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "OrderShippingInfo_facilityId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Contact Mech ID",
            "type" : "HIDDEN",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "contactMechId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "OrderShippingInfo_contactMechId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "20",
            "ajaxUrl" : "",
            "maxlength" : "20",
            "tabindex" : "",
            "className" : "",
            "title" : "Telecom Contact Mech ID",
            "type" : "HIDDEN",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "telecomContactMechId",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "OrderShippingInfo_telecomContactMechId",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "40",
            "ajaxUrl" : "",
            "maxlength" : "40",
            "tabindex" : "",
            "className" : "",
            "title" : "Tracking Number",
            "type" : "HIDDEN",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "trackingNumber",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "OrderShippingInfo_trackingNumber",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "60",
            "ajaxUrl" : "",
            "maxlength" : "250",
            "tabindex" : "",
            "className" : "",
            "title" : "Shipping Instructions",
            "type" : "HIDDEN",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "shippingInstructions",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "OrderShippingInfo_shippingInstructions",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "May Split",
            "type" : "HIDDEN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "ShipGroupsMaster",
            "options" : [ {
            "description" : "Y",
            "key" : "Y"
            }, {
            "description" : "N",
            "key" : "N"
            } ],
            "disabled" : "false",
            "id" : "OrderShippingInfo_maySplit",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "first-in-list",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "maySplit",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "" : "",
            "fieldHelpText" : "",
            "textSize" : "60",
            "ajaxUrl" : "",
            "maxlength" : "250",
            "tabindex" : "",
            "className" : "",
            "title" : "Gift Message",
            "type" : "HIDDEN",
            "clientAutocomplete" : "true",
            "ajaxEnabled" : true,
            "readonly" : false,
            "alert" : "false",
            "name" : "giftMessage",
            "action" : "",
            "style" : "",
            "disabled" : false,
            "id" : "OrderShippingInfo_giftMessage",
            "placeholder" : "",
            "event" : "",
            "value" : "",
            "mask" : ""
        }, {
            "fieldName" : "",
            "firstInList" : "",
            "partialChars" : "",
            "conditionGroup" : "",
            "otherFieldName" : "",
            "className" : "",
            "title" : "Is Gift",
            "type" : "HIDDEN",
            "frequency" : "",
            "minChars" : "",
            "allowEmpty" : "",
            "autoSelect" : "",
            "ajaxEnabled" : "false",
            "noCurrentSelectedKey" : "",
            "ajaxOptions" : "",
            "alert" : "false",
            "otherFieldSize" : "0",
            "ignoreCase" : "",
            "formName" : "ShipGroupsMaster",
            "options" : [ {
            "description" : "Y",
            "key" : "Y"
            }, {
            "description" : "N",
            "key" : "N"
            } ],
            "disabled" : "false",
            "id" : "OrderShippingInfo_isGift",
            "event" : "",
            "otherValue" : "",
            "fullSearch" : "",
            "fieldHelpText" : "",
            "dDFCurrent" : "first-in-list",
            "tabindex" : "",
            "multiple" : "",
            "partialSearch" : "",
            "size" : "1",
            "name" : "isGift",
            "style" : "",
            "explicitDescription" : "",
            "choices" : "",
            "currentValue" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Ship After Date",
            "type" : "HIDDEN",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2025-01-07%2010:33:30.269",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "ShipGroupsMaster",
            "timeDropdownParamName" : "shipAfterDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "OrderShippingInfo_shipAfterDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "",
            "timeHourName" : "",
            "name" : "shipAfterDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Ship By Date",
            "type" : "HIDDEN",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2025-01-07%2010:33:30.272",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "ShipGroupsMaster",
            "timeDropdownParamName" : "shipByDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "OrderShippingInfo_shipByDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "",
            "timeHourName" : "",
            "name" : "shipByDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Estimated Ship Date",
            "type" : "HIDDEN",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2025-01-07%2010:33:30.272",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "ShipGroupsMaster",
            "timeDropdownParamName" : "estimatedShipDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "OrderShippingInfo_estimatedShipDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "",
            "timeHourName" : "",
            "name" : "estimatedShipDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "classString" : "",
            "shortDateInput" : "false",
            "ampmName" : "",
            "className" : "",
            "title" : "Estimated Delivery Date",
            "type" : "HIDDEN",
            "dateType" : "timestamp",
            "defaultDateTimeString" : "2025-01-07%2010:33:30.272",
            "timeDropdown" : "",
            "alert" : "false",
            "timeValues" : "",
            "formName" : "ShipGroupsMaster",
            "timeDropdownParamName" : "estimatedDeliveryDate",
            "timeMinutesName" : "",
            "disabled" : "false",
            "id" : "OrderShippingInfo_estimatedDeliveryDate",
            "event" : "",
            "value" : "",
            "pmSelected" : "",
            "localizedInputTitle" : "",
            "mask" : "",
            "hour1" : "0",
            "isTwelveHour" : "false",
            "fieldHelpText" : "",
            "hour2" : "0",
            "maxlength" : "30",
            "minutes" : "0",
            "tabindex" : "",
            "amSelected" : "",
            "size" : "25",
            "isXMLHttpRequest" : "false",
            "localizedIconTitle" : "",
            "timeHourName" : "",
            "name" : "estimatedDeliveryDate",
            "style" : "",
            "step" : "1",
            "compositeType" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "address1",
            "description" : "",
            "style" : "",
            "id" : "OrderShippingInfo_address1",
            "title" : "Address1",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "address2",
            "description" : "",
            "style" : "",
            "id" : "OrderShippingInfo_address2",
            "title" : "Address2",
            "type" : "HIDDEN",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "city",
            "description" : "",
            "style" : "",
            "id" : "OrderShippingInfo_city",
            "title" : "City",
            "type" : "HIDDEN",
            "imageLocation" : ""
        } ],
        "target" : ""
    },
    {
        "fieldSets" : [ {
            "fieldSetName" : "Default",
            "fields" : [ "orderItemSeqId", "productName", "quantityOrdered", "quantityNotAvailable" ]
        } ],
        "columns" : [ {
            "name" : "shipGroupSeqId",
            "title" : "Ship Group Seq ID"
        }, {
            "name" : "orderItemSeqId",
            "title" : "Ref"
        }, {
            "name" : "productName",
            "title" : "Product Name"
        }, {
            "name" : "quantityOrdered",
            "title" : "Quantity"
        }, {
            "name" : "quantityNotAvailable",
            "title" : "Quantity Not Available"
        } ],
        "formName" : "OrderItemShipGroupAssociations",
        "altTarget" : [ ],
        "formLocation" : "component://kwikstore/widget/OrderViewForms.xml",
        "type" : "list",
        "fields" : [ {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "shipGroupSeqId",
            "description" : "",
            "style" : "",
            "id" : "OrderItemShipGroupAssociations_shipGroupSeqId",
            "title" : "Ship Group Seq ID",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "orderItemSeqId",
            "description" : "",
            "style" : "",
            "id" : "OrderItemShipGroupAssociations_orderItemSeqId",
            "title" : "Ref",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "productName",
            "description" : "",
            "style" : "",
            "id" : "OrderItemShipGroupAssociations_productName",
            "title" : "Product Name",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "quantityOrdered",
            "description" : "",
            "style" : "",
            "id" : "OrderItemShipGroupAssociations_quantityOrdered",
            "title" : "Quantity",
            "type" : "DISPLAY",
            "imageLocation" : ""
        }, {
            "fieldHelpText" : "",
            "ajaxEnabled" : false,
            "size" : 0,
            "name" : "quantityNotAvailable",
            "description" : "",
            "style" : "",
            "id" : "OrderItemShipGroupAssociations_quantityNotAvailable",
            "title" : "Quantity Not Available",
            "type" : "DISPLAY",
            "imageLocation" : ""
        } ],
        "target" : ""

    }
]